export default __webpack_public_path__ + "static/media/man.3b3e6038.png";